import { Award, CheckCircle, Target, Users } from "lucide-react";
import ChartCard from "./components/ChartCard";
import Header from "./components/Header";
import QuickActions from "./components/QuickActions";
import StatCard from "./components/StatCard";
import TargetCard from "./components/TargetCard";
import "./dashboard.css";
import { useOutletContext } from "react-router-dom";
import { useContext } from "react";
import { ProfileContext } from "../../context/ProfileContext";

export default function Dashboard({ onMenuClick }) {
  const { openSidebar } = useOutletContext();
  const { user } = useContext(ProfileContext);

  return (
    <div className="rp-dashboard-container">
      <Header onMenuClick={openSidebar} />
      {user?.type === "referralPartner" && (
        <div className="rp-dashboard-stats-row">
          <StatCard
            title="Target Leads"
            value={user.performance?.targetLeads || 0}
            icon={<Target size={18} color="#9b5de5" />}
            iconBg="#f3ecff"
          />
          <StatCard
            title="Total Leads"
            value={user.performance?.totalLeads || 0}
            percent="12"
            icon={<Users size={18} color="#2a9d8f" />}
            iconBg="#e7f7f3"
          />
          <StatCard
            title="Converted"
            value={user.performance?.convertedClients || 0}
            percent="8"
            icon={<CheckCircle size={18} color="#2ecc71" />}
            iconBg="#eafaf1"
          />
          <StatCard
            title="Qualified Leads"
            value={user.performance?.qualifiedLeads || 0}
            icon={<Award size={18} color="#f4a261" />}
            iconBg="#fff4e6"
          />
        </div>
      )}
      <div className="rp-dashboard-middle-section">
        <ChartCard />
      </div>

      <div className="rp-dashboard-right-panel">
        <TargetCard />
        <QuickActions />
      </div>
    </div>
  );
}
